<script>
    export let _click = () => {};
</script>

<div id='open-scanner-button' on:click={_click} on:keypress={()=>{}}>
    <img src="./assets/images/qr_button.png" alt/>
</div>

<style type='text/scss'>
    #open-scanner-button {
        --size: 35%;
        max-width: 150px;
        min-width: 100px;
        width: var(--size);
        height: auto;
        bottom: 10px;
        right: 10px;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: 100%;
            height: auto;
        }
    }
</style>